import { Box, Link, Typography } from "@mui/material";

const styles = {
  box: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    mt: 1,
    mb: 1,
  },
  label: { whiteSpace: "nowrap", color: "#0103077F" },
};

const ChurchInfoItem = ({
  label,
  value,
}: {
  label: string;
  value: string | undefined;
}) => {
  if (!value) return null;
  const isValidURL = (maybeUrl: string) => {
    try {
      new URL(maybeUrl);
      return true;
    } catch (e) {
      return false;
    }
  };
  return (
    <div>
      <Box sx={styles.box}>
        <Typography align={"left"} sx={styles.label}>
          {`${label}\u00A0`}
        </Typography>
        {isValidURL(value) ? (
          <Link
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            align={"right"}
            href={value}
          >
            {value}
          </Link>
        ) : (
          <Typography
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            align={"right"}
          >
            {value}
          </Typography>
        )}
      </Box>
    </div>
  );
};

export default ChurchInfoItem;
